import { useEffect, useState } from "react";
import { motion, AnimatePresence, useWillChange } from "framer-motion";

import { IoMail } from "react-icons/io5";
import { Icon } from "semantic-ui-react";
import { HiMail, HiPhone } from "react-icons/hi";

import SignInUp from "../../components/SignInUp/SignInUp";
import MailSignup from "./MailSignup";
import PhoneSignup from "./PhoneSignup";
import { popUpVariant } from "../../animateConstant";
import { useNavigate } from "react-router";
import { getFixedStyle } from "../../hook/useDeviceType";
import { usePreviousPagePath } from "../../hook/usePreviousPagePath";
import { IoMdClose } from "react-icons/io";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { notice } from "../../redux/action/action";

const Signup = () => {
  const { t } = useTranslation();
  const i18n_backend_response = (key) => t(`backend_response.${key}`);

  const [chooseSignupMethod, setChooseSignupMethod] = useState("phone");
  // const [isClosing, setIsClosing] = useState(false);

  const navigate = useNavigate();
  const previousPage = usePreviousPagePath();

  const willChange = useWillChange();

  const dispatch = useDispatch();

  useEffect(() => {
    if (Cookies.get("token")) {
      // dispatch(
      //   notice(
      //     i18n_backend_response("You are login, please logout first."),
      //     "warning"
      //   )
      // );

      navigate("/casino");
    }
  }, []);
  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{ willChange }}
      className={`${getFixedStyle()} z-[10000] !p-0 w-full md:w-[400px] min-h-[min(865px,70vh)] bg-base-light-white rounded-[10px] dark:bg-base-deep-black sm:backdrop-blur-none backdrop-blur-md`}
    >
      <section
        variants={popUpVariant}
        initial="initial"
        animate="animate"
        exit="exit"
        style={{ willChange }}
        transition={{
          duration: 0.2,
        }}
        className="h-full rounded-[15px] "
      >
        <section className="flex items-center justify-between h-[60px] px-[25px]">
          <SignInUp signupClass={`!bg-main-color !text-white`} />
          <IoMdClose
            onClick={() => {
              // setIsClosing(true);
              setTimeout(() => {
                navigate(previousPage);
              }, 200);
            }}
            className="!mb-[8px] !text-3xl !text-light-text cursor-pointer"
          />
        </section>
        <section
          className="w-full px-common-padding-x py-[10px] !px-[25px] overflow-y-scroll no-scrollbar"
          style={{ height: "calc( 100% - 60px )" }}
        >
          {/* {chooseSignupMethod === "mail" ? <MailSignup /> : <PhoneSignup />} */}
          {/* <PhoneSignup /> */}
          <MailSignup />
        </section>
      </section>
    </motion.main>
  );
};

export default Signup;
